import { combineReducers, createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";

import { authReducer } from "store/reducers/authReducers";
import { utilReducer } from "store/reducers/utilReducers";
import { commonReducer } from "store/reducers/commonReducers";
import { todoReducer } from "store/reducers/todoReducer";
import { listReducer } from "store/reducers/listReducers";
import { diagnosticsReducer } from "./reducers/diagnosticsReducer";

import syncReduxActions from "utils/syncReduxActions";
import { bookingTreeReducer } from "./reducers/bookingTreeReducer";
import { cachedChartReducer } from "./reducers/cachedChartsReducer";
import { onboardingReducer } from "./reducers/onboardingReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  util: utilReducer,
  common: commonReducer,
  todos: todoReducer,
  list: listReducer,
  diagnostics: diagnosticsReducer,
  bookingTree: bookingTreeReducer,
  cachedCharts: cachedChartReducer,
  onboarding: onboardingReducer,
});

const composeEnhancers =
  (typeof window !== "undefined" && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(reduxThunk, syncReduxActions)));

export type AppState = ReturnType<typeof rootReducer>;
